import listActions from 'src/modules/issues/list/issuesListActions';
import IssuesService from 'src/modules/issues/issuesService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ISSUES_DESTROY';

const issuesDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: issuesDestroyActions.DESTROY_STARTED,
      });

      await IssuesService.destroyAll([id]);

      dispatch({
        type: issuesDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.issues.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/issues');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: issuesDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: issuesDestroyActions.DESTROY_ALL_STARTED,
      });

      await IssuesService.destroyAll(ids);

      dispatch({
        type: issuesDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.issues.destroyAll.success'),
      );

      getHistory().push('/issues');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: issuesDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default issuesDestroyActions;
